import request from '@/utils/request'


export const registerUser = (params) => {
  return request({
    url: `/school/schools/user/others`,
    data: params,
    method: 'post'
  })
}

export const getCode = (params) => {
  return request({
    url: `/school/schools/user/others/phone/code`,
    data: params,
    method: 'post'
  })
}

export const checkPhone = (params) => {
  return request({
    url: `/school/schools/user/others/phone`,
    params,
    method: 'get'
  })
}